import React from "react";

const LocalSalesRep = props => {

    const name = props.account.accountName ? props.account.accountName : props.account.storeName;
    const postal = props.account.postalCode ? props.account.postalCode : props.account.zipcode;

    const link = "https://maps.google.com/?q=";
    const thisAddress = `${props.account.address} ${props.account.city}, ${props.account.state} ${
        postal
        }, ${props.account.country}`;
    const emptyString = '';
    let cityState = `${props.account.city}${!props.account.state ? emptyString : ", "}${props.account.state} ${postal}${!props.account.country ? emptyString : ", "}${!props.account.country ? emptyString : props.account.country}`;
    if (!props.account.address) cityState = emptyString;

    let typeClass = emptyString;

    window.location.href.includes('online') || window.location.href.includes('national')
        && !window.location.href.includes('international') ? typeClass = 'hide-pin' : emptyString;

    const email = props.account.email === emptyString ? emptyString : 'Send Email';
    const website = props.account.website === emptyString ? emptyString : 'Go to Website';
    const phone = props.account.phoneNumber === emptyString ? emptyString : `Phone - ${props.account.phoneNumber}`;
    const pinColor = props.account.isDistributor ? '' : 'dealer-pin-blue';

    const gMapLink = props.account.showOnOnlineView
        ? <p className="dealer-name">{name}</p>
        : <a className="dealer-name" href={`${link}${thisAddress}`} target="_blank">{name}</a>;

    return (
        <div className="dealer-rep-container col-lg-6">
            <a href={`${link}${thisAddress}`} className={`dealer-pin ${pinColor} ${typeClass}`} target="_blank">
                <span>{props.id}</span>
            </a>
            <div className="dealer-address">
                <ul>
                    <li>{gMapLink}</li>
                    <li>
                        <address>{props.account.address}</address>
                        <address>{props.account.addressTwo}</address>
                    </li>
                    <li>{cityState}</li>
                    <li><a href={`tel:${props.account.PhoneNumber}`}>{phone}</a></li>
                    <li><a className="address-email" href={`mailto:${props.account.email}`}>{email}</a></li>
                    <li className="address-website"><a target="_blank" href={props.account.website}>{website}</a></li>
                </ul>
            </div>
        </div>
    );
};

export default LocalSalesRep;
